// removed by extract-text-webpack-plugin
module.exports = {"pic1":"CommandSwiper-pic1","pic2":"CommandSwiper-pic2","pic3":"CommandSwiper-pic3","pic4":"CommandSwiper-pic4","pic5":"CommandSwiper-pic5","pic6":"CommandSwiper-pic6","header":"CommandSwiper-header"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CommandSwiper/index.css
// module id = 1706
// module chunks = 0